<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="content-chapter2" id="calibre_toc_6"><a href="#/OEBPS/5Ingredient_split_006#_idTextAnchor021">Store-Bought Flavor Bombs<span id="_idTextAnchor004"></span> </a></p>
<p class="body_body">There’s no way to make epic five-ingredient meals without a little help from store-bought products. There are some incredible products in this book made with best-in-class ingredients that deliver massive flavor. That’s why I call them flavor bombs. They totally elevate a dish with no effort at all. I am talking about simmer sauces, curry pastes, enchilada sauces, BBQ sauces, condiments, and more. Traditionally speaking, these products are loaded with crap I would never want you to put in your body, but I have found products that have nothing but clean ingredients, and, best of all, they taste awesome! You will discover these bombs all throughout the cookbook and can buy them at most groce<span>ry</span><span> </span><span>stores.</span></p>
<p class="body_body"><img alt="" class="calibre3" src="OEBPS/image/image-378.png"/></p>
<p class="body_body"><span class="shopping-tip-bold-red">Mirepoix:</span> I cheated just a little bit for a few recipes in this cookbook! Any time you see mirepoix in a recipe list, it’s a combination of red onion, carrots, and celery. But technically you can find precut mirepoix in the produce section of many grocery stores, including Trader Joe’s. Some of the recipes were just impossible to make without the veggie base of a mirepoix, so hopefully you can forgive me! If you want to make the mirepoix instead of buying it, here’s what<span> you</span><span> </span><span>need:</span></p>
<p class="mirepoix-recipe--text-variable"><span class="bold4">Mirepoix:</span></p>
<p class="shopping-tips-left-justified-1col"><span class="bold5">• ½ a large red onion, finely</span><span><span class="bold5"> </span></span><span class="bold5">diced</span></p>
<p class="shopping-tips-left-justified-1col"><span class="bold5">• 1 large carrot, peeled and</span><span><span class="bold5"> </span></span><span class="bold5">diced</span></p>
<p class="shopping-tips-left-justified-1col"><span class="bold5">• 2 stalks celery, diced</span></p>
<div class="calibre1" id="calibre_pb_44"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_025.vue?95ce1e60